import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getNestedProperty } from '../../helpers/getNestedProperty';
import { StatusInputWrapper } from '../StatusInputWrapper';

const FullName = ({ t, reduxAppProperty, changeObjectPropertyAction, validateFullName, fullNameError, fullNameValid, setIsError, maxLength }) => {
    // const dispatch = useDispatch()
    const [isFocussed, SetIsFocussed] = useState(false)

    const fullName = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).fullName)

    const handleFullName = (e) => {
        try {
            let name = e.currentTarget.value
            changeObjectPropertyAction('fullName', name);
            validateFullName(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const onBlurFullName = (e) => {
        try {
            SetIsFocussed(false)
            let name = e.currentTarget.value.trim()
            changeObjectPropertyAction('fullName', name);
            validateFullName(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    return (
        <StatusInputWrapper
            isValid={fullNameValid}
            errorMsg={fullNameError}
            t={t}
            label={t('contact_information.full_name')}
            customClasses={'fw-20'}
            id="FullName" name="FullName" type="text"
            isFocussed={isFocussed}
            aria-describedby="full_name"
            onChange={handleFullName}
            onBlur={onBlurFullName}
            onFocus={() => SetIsFocussed(true)}
            value={fullName}
            autoComplete="off"
            maxLength={maxLength ?? "125"}
        />
    )
}

export default withTranslation('common')(FullName)